import { GppGoodRounded } from '@mui/icons-material';

import { ReactComponent as WhiteLogo } from '@assets/logo/white-full.svg';
import Text from '@components/Text';
import { t } from '@i18n';

import './styles.scss';

export default function CheckoutFooter() {
  return (
    <div className="footer">
      <div className="footer-row mb-3 mt-2">
        <GppGoodRounded />
        <Text.small>{t('checkout.footer.safeTransaction')}</Text.small>
      </div>

      <Text.small>{t('common.poweredBy')}</Text.small>
      <WhiteLogo className="footer-logo mb-3" />

      <Text.small>
        {t('checkout.footer.termsPrefix')}{' '}
        <a href="https://ginastee.com/privacy" target="_blank" rel="noreferrer">
          <Text.span>{t('checkout.footer.terms')}</Text.span>
        </a>
      </Text.small>
    </div>
  );
}
